import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer pt-5 mt-5">
      <hr className="horizontal dark mb-5" />
      <div className="footer-container">
        {/* Primera fila con las columnas principales */}
        <div className="footer-row">
          <div className="footer-col footer-col-md-3 mb-4 ms-auto">
            <img src={`${process.env.PUBLIC_URL}/assets/img/sismo.svg`} alt="Logo RSC" className="footer-logo mb-3" />
            <div>
              <h6 className="footer-title footer-title-large">Red Sismológica del Noroeste de México</h6>
            </div>
            <div>
              <ul className="footer-nav flex-row ms-n3">
                <li className="footer-nav-item">
                  <a
                    className="footer-nav-link pe-1"
                    href="https://www.facebook.com/people/Reporte-Sismol%C3%B3gico-Cicese/100064427630444/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook text-lg opacity-8"></i>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a
                    className="footer-nav-link pe-1"
                    href="https://twitter.com/resnom1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-twitter text-lg opacity-8"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-col footer-col-md-2 col-sm-6 col-6 mb-4">
            <div>
              <h6 className="footer-title footer-title-small">Acerca de nosotros</h6>
              <ul className="footer-nav flex-column ms-n3">
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/acerca">
                    Sobre la red
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/instrumentacion">
                    Instrumentación
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/procesamiento">
                    Procesamiento
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/estaciones">
                    Estaciones
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-col footer-col-md-2 col-sm-6 col-6 mb-4">
            <div>
              <h6 className="footer-title footer-title-small">Catálogos</h6>
              <ul className="footer-nav flex-column ms-n3">
                <li className="footer-nav-item">
                  <a
                    className="footer-nav-link"
                    href="https://resnom.cicese.mx/earthquakes/search/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Búsquedas
                  </a>
                </li>
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/boletines">
                    Boletines de Sismicidad
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/reportes-especiales">
                    Reportes Especiales
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-col footer-col-md-2 col-sm-6 col-6 mb-4">
            <div>
              <h6 className="footer-title footer-title-small">Divulgación</h6>
              <ul className="footer-nav flex-column ms-n3">
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/divulgacion">
                    Material de Divulgación
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/preguntas">
                    Preguntas Frecuentes
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/efectos">
                    Efectos de los sismos
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-col footer-col-md-2 col-sm-6 col-6 mb-4 me-auto">
            <div>
              <h6 className="footer-title footer-title-small">Legal</h6>
              <ul className="footer-nav flex-column ms-n3">
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/aviso-legal">
                    Aviso Legal
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link className="footer-nav-link" to="/citarnos">
                    Cómo citarnos
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Segunda fila separada para el copyright */}
        <div className="footer-copyright-row">
          <div className="footer-copyright-container">
            <p className="footer-copyright">
              All rights reserved. Copyright © {currentYear} Red Sísmica del Noroeste de México, Departamento de
              Sismología CICESE. Esta página y su contenido pueden ser reproducidos con fines no lucrativos, siempre y
              cuando no se mutile, se cite la fuente completa y su dirección electrónica. De otra forma, requiere
              autorización previa por escrito de la institución.{" "}
              <a href="https://doi.org/10.7914/SN/BC">doi.org/10.7914/SN/BC</a>.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
